import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import LogoImage from "../../assets/image/logo.png";
import "./login.css";
import { ToastContainer, toast } from "react-toastify";

function Login() {
  const API_BASE_URL = process.env.REACT_APP_BASE_URL; // Ensure this is set correctly in .env
  const [formData, setFormData] = useState({ username: "", password: "" });
  const [errorMessage, setErrorMessage] = useState("");
  const [loading, setLoading] = useState(false); // Added loading state
  const navigate = useNavigate();

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
    setErrorMessage(""); // Reset error message on input change
  };

  const handleLogin = async (e) => {
    e.preventDefault();
    const { username, password } = formData;

    // Input validation
    if (!username || !password) {
      setErrorMessage("Both username and password are required.");
      return;
    }

    setLoading(true); // Show loading state

    try {
      const response = await fetch(`${API_BASE_URL}/User/login`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ username, password }),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const data = await response.json(); // Directly parse the response as JSON
      console.log("Parsed data:", data);

      if (data.status_code === 200) {
        sessionStorage.setItem("auth_code", data.auth_code);
        sessionStorage.setItem("user_id", data.user_id);
        toast.success(`Welcome, ${data.full_name}!`);
        navigate("/take_order"); // Redirect to dashboard
      } else {
        setErrorMessage("Invalid username or password. Please try again.");
        toast.error("Invalid username or password.");
      }
    } catch (error) {
      console.error("Error fetching user data:", error);
      setErrorMessage("Unable to authenticate, please try again later.");
      toast.error("Unable to authenticate, please try again later.");
    } finally {
      setLoading(false); // Hide loading state
    }
  };

  return (
    <>
      <ToastContainer
        className="toast-position"
        position="top-center"
        autoClose={2000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
      <div className="LoginBoxContainer">
        <div className="LoginBox">
          <div className="LoginLogo">
            <img src={LogoImage} alt="Logo" />
          </div>
          <form className="LoginForm" onSubmit={handleLogin}>
            <div className="Form-group">
              <label htmlFor="username">Username</label>
              <input
                type="text"
                name="username"
                value={formData.username}
                onChange={handleInputChange}
                required
              />
            </div>
            <div className="Form-group">
              <label htmlFor="password">Password</label>
              <input
                type="password"
                name="password"
                value={formData.password}
                onChange={handleInputChange}
                required
              />
            </div>
            <div className="Form-group">
              {errorMessage && <p className="ErrorMessage">{errorMessage}</p>}
              <button type="submit" disabled={loading}>
                {loading ? "Logging in..." : "Login"}
              </button>
            </div>
          </form>
        </div>
      </div>
    </>
  );
}

export default Login;
